// extracted by mini-css-extract-plugin
export default {"burgerMenu":"Sidebar_burgerMenu__lIJ4V","sidebar":"Sidebar_sidebar__xWEZw","open":"Sidebar_open__Yy5AV","closeBtn":"Sidebar_closeBtn__xNqXS","menuList":"Sidebar_menuList__z+w+k"};